import { Card } from '@heroui/react';
import { PageContainer } from '@/components/templates/PageContainer';

interface PlaceholderPageProps {
  title: string;
  description?: string;
}

export function PlaceholderPage({ title, description }: PlaceholderPageProps) {
  return (
    <PageContainer>
      <h2 className="text-2xl font-bold mb-4 text-foreground">{title}</h2>
      <Card className="bg-surface">
        <div className="p-4">
          <p className="text-muted">{description ?? 'Раздел в разработке'}</p>
        </div>
      </Card>
    </PageContainer>
  );
}
